if (!customElements.get('carousel-component')) {
    class CarouselComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.Initialize();
        }

        Initialize() {
            this.InitializeSlider()
            this.InitializeSliderControls()
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'))
            }, 10);
        }

        ResetAfter(number) {
            this.onmouseenter = () => {
                clearTimeout(this.ResetTimeout)
            }
            this.ResetTimeout = setTimeout(() => {
                this.Slider?.destroy?.()
                this.InitializeSlider()
            }, number);
        }

        InitializeSlider() {
            const KeenSliderElement = this.querySelector('.keen-slider');
            

            const ParsedInitial = parseInt(this.dataset.initial)
            if (KeenSliderElement) {
                const CycleDelay = parseInt(KeenSliderElement.dataset.cycleDelay) || 3000
                const DragEnabled = !this.hasAttribute('no-drag');
                console.log("DragEnabled", DragEnabled)

                const slider = new KeenSlider(KeenSliderElement,
                    {
                        loop: true,
                        initial: ParsedInitial || theme.InitialCarouselSlide || 0,
                        drag: DragEnabled
                    }, 
                    [
                        (slider) => {
                            this.Slider = slider

                            let CycleTimeout;
                            // const mouseOver = false;
                            function clearNextTimeout() {
                                clearTimeout(CycleTimeout);
                            }
                            const nextTimeout = () => {
                                clearTimeout(CycleTimeout);
                                // if (mouseOver) return;
                                if ( KeenSliderElement.dataset.autoCycle ==='true') {                                   
                                    CycleTimeout = setTimeout(() => { 
                                        slider.next();
                                    }, CycleDelay);
                                }
                            }
                            slider.on('created', () => {
                                nextTimeout();
                            });
                            slider.on('dragStarted', clearNextTimeout);
                            slider.on('animationEnded', () => {
                                if(this.hasAttribute('data-update-header')){
                                    this.UpdateHeader()
                                }
                                nextTimeout()
                            });
                            slider.on('updated', nextTimeout);
                            slider.on("slideChanged", () => {
                                this.SetActiveBar()
                            })
                        },
                    ]
                )
                // this.Slider = slider
            }
        }
        UpdateHeader() {
            theme.HeaderGroup.UpdateTargetElementColor()
        }
        SetActiveBar() {
            const slide = this.Slider.track.details.rel
            Array.from(this.SliderBars).forEach(function (indicator, idx) {
                idx === slide
                  ? indicator.classList.add("Active")
                  : indicator.classList.remove("Active")
            })
            Array.from(this.SliderNumbers).forEach(function (indicator, idx) {
                idx === slide
                  ? indicator.classList.add("Current")
                  : indicator.classList.remove("Current")
            })
        }
        InitializeSliderControls() {
            const Bars = this.querySelectorAll('[data-bar]')
            this.SliderBars = Bars
            const Numbers = this.querySelectorAll('[data-number]')
            this.SliderNumbers = Numbers


            const Controls = this.querySelectorAll('[data-idx]')
            Controls.forEach(Control => Control.addEventListener('click', (event) => {
                event.stopPropagation()
                event.preventDefault()
                this.Slider.moveToIdx(parseInt(Control.dataset.idx))
            }))

            this.InitializeArrows()
        }
        InitializeArrows() {
            const ArrowLeft = this.querySelector('[data-arrow="Left"]')
            ArrowLeft?.addEventListener("click", (event) => {
                event.stopPropagation()
                event.preventDefault()
                this.Slider.prev()
            })

            const ArrowRight = this.querySelector('[data-arrow="Right"]')
            ArrowRight?.addEventListener("click", (event) => {
                event.stopPropagation()
                event.preventDefault()
                this.Slider.next()
            })
        }

    }
    customElements.define('carousel-component', CarouselComponent);
}